module.exports = __webpack_public_path__ + "static/Logo-White-f8e4aadc568693ea23b0deef1ff4e09a.svg";